import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getPinnedPostsKey, getPostKey, getPostsKey } from '../../utils/keys';
export const usePinReplyToPost = (options) => {
    const { useMutationOptions, fields = 'basic' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(variables => client.mutation({
        name: 'pinReplyToPost',
        args: {
            variables,
            fields,
        },
    }), {
        onSettled: (data, error, variables) => {
            queryClient.invalidateQueries(getPostKey({ variables: { id: variables === null || variables === void 0 ? void 0 : variables.postId } }));
            queryClient.invalidateQueries(getPostKey({ variables: { id: variables === null || variables === void 0 ? void 0 : variables.replyId } }));
            queryClient.invalidateQueries(getPostsKey());
            queryClient.invalidateQueries(getPinnedPostsKey());
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=usePinReplyToPost.js.map